<template>
	<div id="top-bar">
		<img src="../assets/logo.svg" class="logo" alt="">
	</div>
</template>

<script>

export default {
	name: 'main-menu'
};
</script>



// WEBPACK FOOTER //
// TopBar.vue?a3fe17a2